import { render, staticRenderFns } from "./PostDetails.vue?vue&type=template&id=76439b0a&scoped=true&"
import script from "./PostDetails.vue?vue&type=script&lang=js&"
export * from "./PostDetails.vue?vue&type=script&lang=js&"
import style0 from "./PostDetails.vue?vue&type=style&index=0&id=76439b0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76439b0a",
  null
  
)

export default component.exports